/* eslint-disable no-plusplus */
import { yupResolver } from "@hookform/resolvers/yup";
import { useMemo, useRef, useState } from "react";
import { useForm, useWatch } from "react-hook-form";
import { useSelector } from "react-redux";
import { useParams } from "react-router";
import FormSchema from "./validation";
import axiosInstanceV2 from "src/utils/axiosV2";
import api from "src/services/api";
import { useMutationCustom, useQueryCustom } from "src/utils/reactQueryHooks";
import persianToEnglishNumber from "src/utils/persianToEnglishNumber";
import { fDateForApi, timeIsAfterToday } from "src/utils/formatTime";
import CustomSwal from "src/utils/swal";
import RemoveNullObjectValue from "src/utils/RemoveNullObjectValue";
import { Box, FormHelperText, Grid, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import WaitingBox from "src/components/WaitingBox";
import { FormProvider, RHFTextField } from "src/components/hook-form";
import RHFDatePicker from "src/components/hook-form/RHFDatePicker";
import HamrahSection from "./component/hamrah";
import ModalLayout from "src/components/ModalLayout";
import QuestionComponent from "src/components/ui/Question";

const FinalSubmitStep2 = ({
    afterOnSubmit = () => null,
    backToPrevForm = () => null,
    mainFormLoading = false,
    showConfirmModal = () => null
}) => {

    const ModalLayoutQuestionInputRef = useRef();

    const queryParams = useParams();
    const { id, travel } = queryParams;

    const admin = useSelector((store) => store.admin.data);
    const travelMainObj = useSelector((store) => store.travel.data);

    const [TravelDataFromStore, setTravelDataFromStore] = useState({})
    const [beforeRegistrant, setBeforeRegistrant] = useState();
    const [DisableInputs, setDisableInputs] = useState(false)

    const [HamrahDataArr, setHamrahDataArr] = useState([]);

    const handleQuestionModal = (params) => ModalLayoutQuestionInputRef.current.show((p) => !p, params);


    const defaultValues = useMemo(
        () => ({
            id: -1,
            name: '',
            last_name: "",
            shenasname: "",
            codeMeli: "",
            father_name: "",
            birthDate: "",
            gender: "",
            email: "",
            phone: "",
            student_number: "",
            type_of_employment_number: "",
            marride_status: null,
            tashrof_be_sorat: null,
            gozarnameh_status: null,
            duty_system: null,
            mazhab: null,
            need_vam: null,
            sabegh_tasharof: null,
            home_phone: null,
            has_hamrah: null,
            hamrah_count: null,
            marrid_date: "",
            student_marriage: null,
            provoince_university: null,
            type_university: null,
            university_code: null,
            kunkor: null,
            degree: null,
            // educational_qualification: null,
            type_of_employment: null,
            type_of_employment_state: null,

            companions: [],
        }),

        []
    );


    const methods = useForm({
        resolver: yupResolver(FormSchema),
        // mode: 'onChange',
        mode: 'all',
        shouldUnregister: false,
        defaultValues: defaultValues
    });

    const {
        reset,
        watch,
        control,
        setValue,
        setError,
        handleSubmit,
        getValues,
        formState: { errors, isSubmitting },
    } = methods;

    const isError = Object.keys(errors)?.length;
    
    console.log({errors})

    const genderWatcher = useWatch({ control, name: 'gender' });
    const mirrageStatusWatcher = useWatch({ control, name: 'marride_status' });
    const tasharofWatcher = useWatch({ control, name: 'tashrof_be_sorat' });
    const hasHamragWatcher = useWatch({ control, name: 'has_hamrah' });
    const hamrahCountWatcher = useWatch({ control, name: 'hamrah_count' });
    const companions = useWatch({ control, name: 'companions' });

    const creating = (params) => axiosInstanceV2.post(api.public.travelRegister.base, params);
    const updating = (params) => axiosInstanceV2.put(`${api.public.travelRegister.base}/${travel}`, params);
    const getById = () => axiosInstanceV2.get(`${api.form.base}/${travel}`);

    const onSuccessMutating = () => {
        // handleSuccessModal();
        afterOnSubmit();
    };

    const { isLoading, mutate } = useMutationCustom({
        url: updating,
        name: `${api.public.travelRegister.base}_add_first`,
        // invalidQuery: `${Enum?.api?.base}_get_${id}_${travel}`,
        onSuccess: onSuccessMutating,
        //  onError: onErrorMutating,
    });

    const handleGetUserFormData = (data) => {

        const userFormData = data?.data?.clients?.[0];
        const userFormClientsData = data?.data?.clients;

        if (userFormData) {
            const userInputStructure = {
                id: userFormData?.id,
                name: userFormData?.name ? userFormData?.name : "",
                last_name: userFormData?.last_name ? userFormData?.last_name : "",
                shenasname: userFormData?.shenasname_number ? userFormData?.shenasname_number : "",
                codeMeli: userFormData?.code_melli,
                father_name: userFormData?.father_name ? userFormData?.father_name : "",
                birthDate: userFormData?.birthdate ? new Date(userFormData?.birthdate) : "",
                gender: userFormData?.gender ? { label: userFormData?.gender, value: userFormData?.gender } : "",
                email: userFormData?.email ? userFormData?.email : "",
                phone: userFormData?.phone,
                student_number: userFormData?.student_number ? userFormData?.student_number : "",
                marride_status: userFormData?.marital_status ? { label: userFormData?.marital_status, value: userFormData?.marital_status } : null,
                tashrof_be_sorat: userFormData?.tasharof_be_soorat ? { label: userFormData?.tasharof_be_soorat, value: userFormData?.tasharof_be_soorat } : null,
                gozarnameh_status: userFormData?.passport_status ? { label: userFormData?.passport_status, value: userFormData?.passport_status } : null,
                duty_system: userFormData?.nezam_vazife_status ? { label: userFormData?.nezam_vazife_status, value: userFormData?.nezam_vazife_status } : null,
                mazhab: userFormData?.religion ? { label: userFormData?.religion, value: userFormData?.religion } : null,
                need_vam: userFormData?.need_vam ? { label: userFormData?.need_vam, value: userFormData?.need_vam } : null,
                sabegh_tasharof: userFormData?.sabeghe_tasharof ? { label: userFormData?.sabeghe_tasharof, value: userFormData?.sabeghe_tasharof } : null,
                home_phone: userFormData?.home_phone ? userFormData?.home_phone : "",
                has_hamrah: userFormData?.has_hamrah ? { label: userFormData?.has_hamrah, value: userFormData?.has_hamrah } : null,
                hamrah_count: userFormData?.hamrah_count ? { label: userFormData?.hamrah_count, value: userFormData?.hamrah_count } : null,
                marrid_date: userFormData?.marriage_date ? new Date(userFormData?.marriage_date) : "",
                student_marriage: userFormData?.student_marriage ? { label: userFormData?.student_marriage, value: userFormData?.student_marriage } : null,
                provoince_university: userFormData?.university_city ? { label: userFormData?.university_city, value: userFormData?.university_city } : null,
                type_university: userFormData?.university_category ? { label: userFormData?.university_category, value: userFormData?.university_category } : null,
                university_code: userFormData?.university_name ? { label: userFormData?.university_name, value: userFormData?.university_name } : null,
                kunkor: userFormData?.konkoor ? { label: userFormData?.konkoor, value: userFormData?.konkoor } : null,
                degree: userFormData?.education_level ? { label: userFormData?.education_level, value: userFormData?.education_level } : null,
                // educational_qualification: null,
                type_of_employment: userFormData?.hokm_kargozini ? { label: userFormData?.hokm_kargozini, value: userFormData?.hokm_kargozini } : null,
                type_of_employment_state: userFormData?.university_level ? { label: userFormData?.university_level, value: userFormData?.university_level } : null,
                type_of_employment_number: userFormData?.hokm_kargozini_number ? userFormData?.hokm_kargozini_number : "",
                companions: []
            }

            if (parseInt(userFormData?.hamrah_count, 10) > 0) {
                for (let i = 1; i < userFormClientsData.length; i++) {
                    const element = userFormClientsData[i];
                    const currentCompanionData = {
                        id: element?.id,
                        name: element?.name,
                        last_name: element?.last_name,
                        shenasname: element?.shenasname_number,
                        code_meli: element?.code_melli,
                        father_name: element?.father_name,
                        birthDate: new Date(element?.birthdate),
                        gender: { label: element?.gender, value: element?.gender },
                        email: element?.email,
                        phone: element?.phone,
                        student_number: element?.student_number ? element?.student_number : "",
                        marride_status: { label: element?.marital_status, value: element?.marital_status },
                        tashrof_be_sorat: { label: element?.tasharof_be_soorat, value: element?.tasharof_be_soorat },
                        gozarnameh_status: { label: element?.passport_status, value: element?.passport_status },
                        duty_system: element?.nezam_vazife_status ? { label: element?.nezam_vazife_status, value: element?.nezam_vazife_status } : null,
                        mazhab: { label: element?.religion, value: element?.religion },
                        need_vam: element?.need_vam ? { label: element?.need_vam, value: element?.need_vam } : null,
                        sabegh_tasharof: { label: element?.sabeghe_tasharof, value: element?.sabeghe_tasharof },
                        home_phone: element?.home_phone,
                        student_marriage: element?.student_marriage ? { label: element?.student_marriage, value: element?.student_marriage } : null,
                        provoince_university: element?.university_city ? { label: element?.university_city, value: element?.university_city } : null,
                        type_university: element?.university_category ? { label: element?.university_category, value: element?.university_category } : null,
                        university_code: element?.university_name ? { label: element?.university_name, value: element?.university_name } : null,
                        kunkor: element?.konkoor ? { label: element?.konkoor, value: element?.konkoor } : null,
                        degree: element?.education_level ? { label: element?.education_level, value: element?.education_level } : null,
                        is_Student: { label: element?.is_student, value: element?.is_student },
                        // educational_qualification: null,
                        type_of_employment: element?.hokm_kargozini ? { label: element?.hokm_kargozini, value: element?.hokm_kargozini } : null,
                        type_of_employment_state: element?.university_level ? { label: element?.university_level, value: element?.university_level } : null,
                    }
                    userInputStructure.companions.push(currentCompanionData)
                }
            }

            setBeforeRegistrant(true)
            reset(userInputStructure)
        }

    }

    const firstFormOfTravel = useQueryCustom({
        url: getById,
        name: `${api.public.travelRegister.base}_getById_first`,
        params: { id: travel },
        // invalidQuery: `${Enum?.api?.base}_get_${id}_${travel}`,
        onSuccess: handleGetUserFormData,
        enabled: !!admin?.id
        //  onError: onErrorMutating,
    });


    const isDuplicateInArray = (arr, key) => {
        const seen = new Set();

        for (const item of arr) {
            if (seen.has(item[key])) {
                return true; // Duplicate found
            }
            seen.add(item[key]);
        }

        return false; // No duplicates
    };


    const onSubmit = async () => {

        const formValue = getValues();

        handleQuestionModal();

        console.log({
            formValue,
            // reqData
        })

        const reqData = {
            travel_id: travel,
            name: formValue.name,
            last_name: formValue.last_name,
            student_number: formValue.tashrof_be_sorat?.value !== "استاد دانشگاه" ? persianToEnglishNumber(formValue.student_number) : undefined,
            code_melli: persianToEnglishNumber(formValue.codeMeli),
            phone: persianToEnglishNumber(formValue.phone),
            shenasname_number: persianToEnglishNumber(formValue.shenasname),
            father_name: formValue.father_name,
            birthdate: persianToEnglishNumber(fDateForApi(formValue.birthDate)),
            gender: formValue.gender?.value,
            email: formValue.email !== "" ? formValue.email : undefined,
            marital_status: formValue.marride_status?.value,
            tasharof_be_soorat: formValue.tashrof_be_sorat?.value,
            religion: formValue.mazhab?.value,
            home_phone: persianToEnglishNumber(formValue.home_phone),
            passport_status: formValue.gozarnameh_status?.value,
            nezam_vazife_status: formValue?.gender?.value === "مذکر" ? formValue.duty_system?.value : undefined,
            need_vam: formValue.need_vam?.value,
            sabeghe_tasharof: formValue.sabegh_tasharof?.value,
            marriage_date: (formValue.tashrof_be_sorat?.value === "دانشجویان متاهل" && formValue.marride_status?.value === "متاهل") ? persianToEnglishNumber(fDateForApi(formValue.marrid_date)) : undefined,
            student_marriage: (formValue.tashrof_be_sorat?.value === "دانشجویان متاهل" && formValue.marride_status?.value === "متاهل") ? formValue.student_marriage?.value : undefined,
            has_hamrah: (formValue.tashrof_be_sorat.value?.search("مجرد") === -1 && formValue.has_hamrah?.value) ? formValue.has_hamrah?.value : "خیر",
            hamrah_count: (formValue.tashrof_be_sorat.value?.search("مجرد") === -1 && formValue.hamrah_count?.value && formValue.has_hamrah?.value === "بله") ? persianToEnglishNumber(formValue.hamrah_count?.value) : 0,
            nesbat_to_head: "سرگروه",
            university_city: formValue.provoince_university?.label,
            university_category: formValue.type_university?.label,
            university_name: formValue.university_code?.label,
            konkoor: formValue.kunkor?.value,
            education_level: formValue.degree?.value,
            is_student: (formValue.tashrof_be_sorat?.value === "استاد دانشگاه" || formValue.tashrof_be_sorat?.value === "کارمند") ? "خیر" : "بله",
            hokm_kargozini: formValue.tashrof_be_sorat?.value === "استاد دانشگاه" ? formValue?.type_of_employment?.value : undefined,
            university_level: formValue.tashrof_be_sorat?.value === "استاد دانشگاه" ? formValue?.type_of_employment_state?.value : undefined,
            hokm_kargozini_number: formValue.tashrof_be_sorat?.value === "استاد دانشگاه" ? persianToEnglishNumber(formValue.type_of_employment_number) : undefined,
        }

        // reqData = RemoveNullObjectValue(reqData);


        if (
            parseInt(formValue.hamrah_count?.value, 10) > 0 &&
            formValue.has_hamrah.value === "بله" &&
            formValue.tashrof_be_sorat.value?.search("مجرد") === -1
        ) {
            reqData.array = [];

            for (let i = 0; i < parseInt(formValue.hamrah_count?.value, 10); i++) {

                if (persianToEnglishNumber(formValue.codeMeli) === persianToEnglishNumber(formValue?.companions[i]?.code_meli)) {
                    // toast.error(`کد ملی وارد شده با یکی از همراهان مشابه است ، لطفا آن را ویرایش کنید`)
                    CustomSwal.fire({
                        title: '',
                        text: `کد ملی وارد شده با یکی از همراهان مشابه است ، لطفا آن را ویرایش کنید`,
                        icon: 'error',
                        confirmButtonText: 'بستن'
                    })
                    return
                }

                if (persianToEnglishNumber(formValue.phone) === persianToEnglishNumber(formValue?.companions[i]?.phone)) {
                    // toast.error(`شماره همراه وارد شده با یکی از همراهان مشابه است ، لطفا آن را ویرایش کنید`)
                    CustomSwal.fire({
                        title: '',
                        text: `شماره همراه وارد شده با یکی از همراهان مشابه است ، لطفا آن را ویرایش کنید`,
                        icon: 'error',
                        confirmButtonText: 'بستن'
                    })
                    return
                }

                const element = {
                    'name': formValue?.companions[i]?.name,
                    'last_name': formValue?.companions[i]?.last_name,
                    'code_melli': persianToEnglishNumber(formValue?.companions[i]?.code_meli),
                    'phone': persianToEnglishNumber(formValue?.companions[i]?.phone),
                    // 'shenasname_number' : persianToEnglishNumber(formValue?.companions[i]?.name) ,
                    'father_name': formValue?.companions[i]?.father_name,
                    'birthdate': persianToEnglishNumber(fDateForApi(formValue?.companions[i]?.birthDate)),
                    'gender': formValue?.companions[i]?.gender?.value,
                    'passport_status': formValue?.companions[i]?.gozarnameh_status?.value,
                    'nezam_vazife_status': formValue?.companions[i]?.gender?.value === "مذکر" ? formValue?.companions[i]?.duty_system?.value : undefined,
                    'need_vam': i == 0 ? formValue?.companions[i]?.need_vam?.value : "نیستم",
                    'nesbat_to_head': i === 0 ? "همسر" : "فرزند",
                    'university_city': formValue?.companions[i]?.is_Student?.value === "بله" ? formValue?.companions[i]?.provoince_university?.label : undefined,
                    'university_category': formValue?.companions[i]?.is_Student?.value === "بله" ? formValue?.companions[i]?.type_university?.label : undefined,
                    'university_name': formValue?.companions[i]?.is_Student?.value === "بله" ? formValue?.companions[i]?.university_code?.label : undefined,
                    'konkoor': formValue?.companions[i]?.is_Student?.value === "بله" ? formValue?.companions[i]?.kunkor?.value : undefined,
                    'education_level': formValue?.companions[i]?.is_Student?.value === "بله" ? formValue?.companions[i]?.degree?.value : undefined,
                    "student_number": formValue?.companions[i]?.is_Student?.value === "بله" ? persianToEnglishNumber(formValue?.companions[i]?.student_number) : undefined,
                    'is_student': formValue?.companions[i]?.is_Student?.value,
                }

                reqData.array.push(RemoveNullObjectValue(element));

            }
        }

        if (isDuplicateInArray(formValue?.companions, "code_meli")) {
            // toast.error("کدملی همراه ها مشابه یک دیگر هستند لطفا آن را ویرایش کنید.")
            CustomSwal.fire({
                title: '',
                text: `کدملی همراه ها مشابه یک دیگر هستند لطفا آن را ویرایش کنید.`,
                icon: 'error',
                confirmButtonText: 'بستن'
            })
            return
        }

        if (isDuplicateInArray(formValue?.companions, "phone")) {
            // toast.error("شماره همراه ،  همراه ها مشابه یک دیگر هستند لطفا آن را ویرایش کنید.")
            CustomSwal.fire({
                title: '',
                text: `شماره همراه ،  همراه ها مشابه یک دیگر هستند لطفا آن را ویرایش کنید.`,
                icon: 'error',
                confirmButtonText: 'بستن'
            })
            return
        }

        mutate(reqData);

    }

    const handleCheckUserCanEditInputs = (inputLabel = "") => {
        // console.log({travelMainObj : TravelDataFromStore})
        if (admin?.has_won_lottery == 6) {
            if (
                inputLabel === "کدملی" ||
                inputLabel === "تلفن همراه"
            ) {
                setDisableInputs(true)
                return true
            }
            if (admin?.add_by_admin) {
                if (TravelDataFromStore?.type_finish_at && timeIsAfterToday(TravelDataFromStore?.type_finish_at)) {
                    setDisableInputs(true)
                    return true
                }
                setDisableInputs(false)
                return false
            }
            setDisableInputs(true)
            return true
        }
        if (
            inputLabel === "کدملی" ||
            inputLabel === "تلفن همراه"
        ) {
            if (admin?.id) {
                setDisableInputs(true)
                return true
            }
        }
        setDisableInputs(false)
        return false
    }




    return (
        <>

            <ModalLayout ref={ModalLayoutQuestionInputRef}>
                <QuestionComponent
                    {...{
                        title: 'آیا از تایید اطلاعات خود مطمئن هستید؟',
                        description: "",
                        button: {
                            confirm: {
                                label: 'question.yesProcess',
                                loading: mainFormLoading,
                                onClick: (_, data) => onSubmit(data),
                            },
                            reject: {
                                label: 'question.no',
                                onClick: () => handleQuestionModal(),
                            },
                        },
                    }}
                // onClose={() => handleQuestionModal()}
                />
            </ModalLayout>

            {firstFormOfTravel?.isLoading ? <WaitingBox /> :
                <>
                    <FormProvider methods={methods} onSubmit={handleSubmit(handleQuestionModal)}>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 4,
                            }}
                        >
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    p: 2,
                                    backgroundColor: 'grey.main',
                                    borderRadius: '8px',
                                }}
                            >
                                <Typography>اطلاعات وارد شده باید با ثبت احوال مطابقت داشته باشد (مجددا کنترل و در صورت نیاز ویرایش نموده و تایید نمائید)</Typography>

                            </Box>
                            <Grid sx={{}} container spacing={3}>
                                <Grid item xs={12} md={6}>
                                    <RHFTextField
                                        name={"name"}
                                        label={"نام"}
                                        required
                                        // disabled={admin?.has_won_lottery == 6}
                                        disabled={DisableInputs}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <RHFTextField
                                        name={"last_name"}
                                        label={"نام خانوادگی"}
                                        required
                                        disabled={DisableInputs}
                                    />
                                </Grid>
                                {/* <Grid item xs={12} md={6}>
                                    <RHFTextField
                                        name={"shenasname"}
                                        label={"شماره شناسنامه"}
                                        type={"numbers"}
                                        disableComma
                                        withZero
                                        required
                                        disabled={DisableInputs}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <RHFTextField
                                        name={"codeMeli"}
                                        label={"کدملی"}
                                        type={"numbers"}
                                        disableComma
                                        withZero
                                        required
                                        disabled={!!admin?.id}
                                    // disabled={handleCheckUserCanEditInputs("کدملی")}
                                    />
                                </Grid> */}
                                <Grid item xs={12} md={6}>
                                    <RHFTextField
                                        name={"father_name"}
                                        label={"نام پدر"}
                                        required
                                        disabled={DisableInputs}
                                    />
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <RHFDatePicker
                                        name={"birthDate"}
                                        label={"تاریخ تولد"}
                                        pickerProps={{
                                            maxDate: new Date(),
                                        }}
                                        required
                                        disabled={DisableInputs}
                                    />
                                </Grid>

                            </Grid>

                        </Box>

                        {(
                            (mirrageStatusWatcher?.value && mirrageStatusWatcher?.value === "متاهل") &&
                            tasharofWatcher?.value?.search("مجرد") === -1 &&
                            parseInt(hamrahCountWatcher?.value, 10) > 0 &&
                            hasHamragWatcher.value === "بله"
                        ) &&
                            <>

                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: 4,
                                        mt: 3
                                    }}
                                >
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            p: 2,
                                            backgroundColor: 'grey.main',
                                            borderRadius: '8px',
                                        }}
                                    >
                                        <Typography>اطلاعات همراهان</Typography>

                                    </Box>
                                    {Array(parseInt(hamrahCountWatcher?.value, 10)).fill("").map((_, index) =>
                                        <>

                                            <HamrahSection index={index} key={`hamrah-${index}`} HamrahDataArr={HamrahDataArr} setHamrahDataArr={HamrahDataArr} getValues={getValues} />
                                        </>
                                    )}


                                </Box>

                            </>
                        }




                        {(
                            // admin?.has_won_lottery != 6
                            // !handleCheckUserCanEditInputs("")
                            !DisableInputs
                        ) &&
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    gap: 2,
                                    mt: 5,
                                }}
                            >
                                <LoadingButton loading={isLoading || mainFormLoading} onClick={backToPrevForm} variant="outlined" color={'success'}>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            gap: 2,
                                            alignItems: 'center',
                                        }}
                                    >
                                        <Typography>بازگشت</Typography>
                                        {/* <ControlPoint /> */}
                                    </Box>
                                </LoadingButton>
                                <LoadingButton loading={isLoading || mainFormLoading} type="submit" variant="contained" color={'success'}>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            gap: 2,
                                            alignItems: 'center',
                                        }}
                                    >
                                        <Typography>ثبت نهایی</Typography>
                                        {/* <ControlPoint /> */}
                                    </Box>
                                </LoadingButton>
                            </Box>
                        }
                        {isError ? (
                            <Box
                                sx={{
                                    display: 'flex',
                                    width: '100%',
                                    justifyContent: 'center',
                                    mt: 1,
                                }}
                            >
                                <FormHelperText error>{`لطفا تمام فیلد ها را با دقت پر نمایید`}</FormHelperText>
                            </Box>
                        ) : (
                            ''
                        )}
                    </FormProvider>
                </>
            }
        </>
    );
}

export default FinalSubmitStep2;